import { Button, ButtonVariant } from '../elements/Button';
import { Divider } from '../elements/Divider';

interface FormSubmitFooterProps {
  handleSubmit?: () => void;
  loading?: boolean;
  disabled?: boolean;
}

const FormSubmitFooter = ({
  handleSubmit,
  loading,
  disabled,
}: FormSubmitFooterProps) => {
  return (
    <div>
      <Divider customStyle='mt-5' />
      <div className='flex justify-between items-center mt-[30px]'>
        <Button
          variant={ButtonVariant.Ghost}
          onClick={() => window.close()}
          label={'Go Back'}
        />
        {handleSubmit && (
          <Button
            variant={ButtonVariant.Default}
            onClick={handleSubmit}
            label={'Save Changes'}
            loading={loading}
            className='w-[130px]'
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
};

export default FormSubmitFooter;
